import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LeaderboardIdeaDto, LeaderboardUserDto } from './leaderboard-api.types';

@Injectable({ providedIn: 'root' })
export class LeaderboardApiService {
  constructor(private readonly http: HttpClient) {}

  getUsers(sort: string, limit = 50): Observable<LeaderboardUserDto[]> {
    const params: Record<string, string> = { limit: String(limit) };
    const s = (sort ?? '').trim();
    if (s) params['sort'] = s;
    return this.http.get<LeaderboardUserDto[]>('/api/leaderboard/users', { params });
  }

  getTopIdeas(limit = 50): Observable<LeaderboardIdeaDto[]> {
    return this.http.get<LeaderboardIdeaDto[]>('/api/leaderboard/ideas', {
      params: { limit: String(limit) }
    });
  }
}

